module.exports = __webpack_public_path__ + "img/logo--sygnet.a2234eb8.svg";